var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "summernote-wrapper"
  }, [_c('div', {
    ref: "summernote"
  }), _c('Modal', {
    attrs: {
      "modalVisible": _vm.modalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeModal
    },
    scopedSlots: _vm._u([{
      key: "modal-content",
      fn: function () {
        return [_c('div', {
          staticClass: "text-left"
        }, [_c('h3', {
          staticClass: "text-lg font-bold mb-4"
        }, [_vm._v("Edit Alt Text")]), _c('div', {
          staticClass: "mb-4"
        }, [_c('label', {
          staticClass: "block text-sm font-medium mb-1"
        }, [_vm._v("Alt Text")]), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.currentAltText,
            expression: "currentAltText"
          }],
          staticClass: "w-full border rounded px-3 py-2 focus:ring focus:ring-blue-400 focus:border-blue-400",
          attrs: {
            "type": "text",
            "placeholder": "Enter description for image"
          },
          domProps: {
            "value": _vm.currentAltText
          },
          on: {
            "keyup": function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.saveAltText.apply(null, arguments);
            },
            "input": function ($event) {
              if ($event.target.composing) return;
              _vm.currentAltText = $event.target.value;
            }
          }
        })]), _c('div', {
          staticClass: "flex justify-end space-x-2"
        }, [_c('button', {
          staticClass: "px-4 py-2 text-gray-600 hover:text-gray-800",
          on: {
            "click": _vm.closeModal
          }
        }, [_vm._v(" Cancel ")]), _c('button', {
          staticClass: "bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded font-medium transition",
          on: {
            "click": _vm.saveAltText
          }
        }, [_vm._v(" Save ")])])])];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }